import { useCallback } from "react";
import { useAuthContext } from "./useAuthContext";


export const useLogout = () => {
  const { dispatch } = useAuthContext();

  const logout = useCallback(() => {
    // remove user from storage
    localStorage.removeItem("user");

    // dispatch logout action
    dispatch({ type: "LOGOUT" });
  }, [dispatch]);
  return { logout };
};
